export enum PostScoreModalId {
  ADD_PLAYER = 'post-score:add-player-modal',
}

export enum ProfileModalId {
  ACTION_PENDING_SCORE = 'profile:action-pending-score-modal',
  INFO_PENDING_SCORE = 'profile:info-pending-score-modal',
}

export enum WatchlistsModalId {
  RENAME_WATCHLIST = 'watchlists:rename-watchlist-modal',
  DELETE_WATCHLIST = 'watchlists:delete-watchlist-modal',
  CREATE_WATCHLIST = 'watchlists:create-watchlist-modal',
  ADD_OR_MANAGE_PLAYER = 'watchlists:add-or-manage-player-to-watchlist-modal',
}

export enum AddOrManagePlayerModalMode {
  ADD = 'add-player',
  MANAGE = 'manage-player',
}

export const watchlistsModalsState = {
  modals: {
    [WatchlistsModalId.RENAME_WATCHLIST]: {
      isOpen: false,
      watchlistId: '',
    },
    [WatchlistsModalId.DELETE_WATCHLIST]: {
      isOpen: false,
      watchlistId: '',
    },
    [WatchlistsModalId.CREATE_WATCHLIST]: {
      isOpen: false,
    },
  },
}

export type WatchlistsModalsState = typeof watchlistsModalsState.modals
